import { notification } from 'doraemon';
import {
  getDistrictsList,
  getDistrictsManageList,
  setDistrictsManage,
  getProvinceDistrictList,
  getInstitutionList,
  getCostControlRule,
  getTagCombineList,
  reqAccountingList,
  reqAccountingDetail,
  reqAccountingSaveOrUpdate
} from '../services/districtManage';

const responseErrorHandle = (res) => {
  const { success, message } = res;
  if (!success) {
    notification.error({
      message: message || '请求出错了',
    });
  }
  return success;
};

export default {
  namespace: 'zoningDistrictManage',
  state: {
  },
  effects: {
    // // 获取区划管理列表
    * getDistrictsList ({ payload }, { call }) {
      const res = yield call(getDistrictsList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取区划负责人列表
    * getDistrictsManageList ({ payload }, { call }) {
      const res = yield call(getDistrictsManageList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 设置区划负责人
    * setDistrictsManage ({ payload }, { call }) {
      const res = yield call(setDistrictsManage, payload);
      responseErrorHandle(res);
      return res;
    },
    // // 获取省级区划
    // * getProvinceDistrictList ({ payload }, { call }) {
    //   const res = yield call(getProvinceDistrictList, payload);
    //   responseErrorHandle(res);
    //   return res;
    // },
    // 分页查询机构下级单位列表
    * getInstitutionList ({ payload }, { call }) {
      const res = yield call(getInstitutionList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 根据区划code查询费控规则
    * getCostControlRule ({ payload }, { call }) {
      const res = yield call(getCostControlRule, payload);
      responseErrorHandle(res);
      return res;
    },
    // 标签联合查询
    * getTagCombineList ({ payload }, { call }) {
      const res = yield call(getTagCombineList, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 核算系统枚举列表
    * getAccountingList ({ payload }, { call }) {
      const res = yield call(reqAccountingList, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 获取区划下核算系统详情
    * getAccountingDetail ({ payload }, { call }) {
      const res = yield call(reqAccountingDetail, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 保存更新区划下的核算系统
    * handleAccountingSaveOrUpdate ({ payload }, { call }) {
      const res = yield call(reqAccountingSaveOrUpdate, payload);
      responseErrorHandle(res);
      return res || {};
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
